<template>
  <transition name="fade">
    <box v-show="show" style="width:60vw;height: 50vh">
      <template v-slot:body>
        <!-- <img src="@/assets/lin-2.png" class="box-lin" /> -->
        <img src="@/assets/straight.gif" class="box-lin" />
        <div class="main">
          <p class="main-header">
            <span class="username">&nbsp;&nbsp;{{ username }}&nbsp;&nbsp;</span
            >，經理不讓我請假，我爸爸又是第一次來臺北，你覺得我該怎麼做？
          </p>
        </div>
        <div class="bottom">
          <div v-for="(item, index) in items" :key="index">
            <transition name="fade">
              <choice
                v-if="item.display"
                :style="item.style"
                :text="item.text"
                :disable="disableChoice"
                @goNext="goToNext(index)"
              ></choice>
            </transition>
          </div>
        </div>
      </template>
    </box>
  </transition>
</template>
<script>
import Box from "@/components/Box";
import Choice from "@/components/Choice.vue";
import { mapState } from "vuex";

export default {
  components: { Box, Choice },
  data() {
    return {
      show: false,
      disableChoice: false,
      items: [
        {
          text: "１。不管工作了！就去車站接爸爸。",
          replyText: "但我可能會丟了工作，家裡需要我這份收入。",
          style: { "min-height": "16vh", "animation-duration": "1.5s" },
          display: true
        },
        {
          text: "２。經理不讓請假，只好乖乖工作。",
          replyText: "爸爸對不起，你在車站等我一下……",
          style: { "min-height": "16vh", "animation-duration": "1.5s" },
          display: true
        },
        {
          text: "３。如果是我，我也不知道怎麼辦。",
          replyText: "我對這一切感到無可奈何。",
          style: { "min-height": "16vh", "animation-duration": "1.5s" },
          display: true
        }
      ]
    };
  },
  mounted() {
    if (this.username === null) this.$store.dispatch("setUsername", "guest");
    setTimeout(() => {
      this.show = true;
    }, 300);
  },
  methods: {
    goToNext(index) {
      this.items[index].display = false;
      this.$nextTick(() => {
        this.items[index].display = true;
      });

      this.items[index].text = this.items[index].replyText;
      this.items[index].style["background-color"] = "#965151";
      this.items[index].style["color"] = "white";
      this.disableChoice = true;

      setTimeout(() => {
        this.$router.push("sad");
      }, 2000);
    }
  },
  computed: {
    ...mapState(["username"])
  }
};
</script>
<style lang="scss" scoped>
.main {
  margin-top: 3em;
  padding-left: 5em;

  .main-header {
    width: 80%;
    margin-top: 1.2em;
    font-size: 1.5em;
    font-weight: bold;
    color: #965151;
    text-align: justify;
  }
  .username {
    color: #965151;
    white-space: pre;
    display: inline-block;
    border: 1px solid transparent;
    border-width: 0 0 3px 0;
    border-image: linear-gradient(
      90deg,
      #965151 50%,
      rgba(150, 81, 81, 0.0224164) 104.35%,
      rgba(150, 81, 81, 0) 105.59%
    );
    border-image-slice: 1;
  }
}
.bottom {
  margin-top: 2.5em;
  padding-left: 5em;
}
.box-lin {
  position: absolute;
  bottom: -8em;
  right: -4em;
  height: 18vw;
}

.input {
  background-color: #fff;
  line-height: 2em;
  padding: 0.5rem 0.5rem;
  margin: 0.5rem 0;
  width: 50%;
  border-radius: 5px;
  border: none;
  outline: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
